import { Button } from "antd"
import { FC } from "react"
import "./OrgItem.less"

type Props = {
  it: OrganizationEntity
  onClick: (slug: Maybe<string>) => void
}
const OrgItem: FC<Props> = ({ it, onClick }) => {
  return (
    <Button block className={"org-item-btn"} onClick={() => onClick(it?.attributes?.slug)}>
      <img src={it?.attributes?.logoWithCompanyName?.data?.attributes?.url} alt={"logo"} />
    </Button>
  )
}

export default OrgItem
